import * as React from 'react';

export const useIsOverflow = (ref, refInner, callback) => {
  const [isOverflow, setIsOverflow] = React.useState(undefined);
  const [needsScrollingLeft, setNeedsScrollingLeft] = React.useState(undefined);
  const [needsScrollingRight, setNeedsScrollingRight] = React.useState(undefined);

  React.useLayoutEffect(() => {
    const { current } = ref;
    const currentInner = refInner.current

    const trigger = () => {
      const hasOverflow = current.scrollWidth > current.clientWidth;

      setIsOverflow(hasOverflow);

      if (callback) callback(hasOverflow);
    };

    const scrollTrigger = () => {
      let innerLeft
      let innerRight
      let outerLeft
      let outerRight

      if(currentInner) {
        innerLeft = Math.floor(currentInner.getBoundingClientRect().left)
        innerRight = Math.floor(currentInner.getBoundingClientRect().right)
        outerLeft = Math.floor(current.getBoundingClientRect().left)
        outerRight = Math.floor(current.getBoundingClientRect().right)
      }

      const scrollLeft = (outerLeft - 5) > innerLeft 
      const scrollRight = (outerRight + 5) < innerRight 

      setNeedsScrollingLeft(scrollLeft)
      setNeedsScrollingRight(scrollRight)


      if (callback) callback(needsScrollingLeft, needsScrollingRight);
    }

    if (current) {
      if ('ResizeObserver' in window) {
        new ResizeObserver(trigger).observe(current);
      }

      current.addEventListener("scroll", () => (scrollTrigger()));
      
      trigger();
      scrollTrigger();
    }
  }, [callback, ref]);

  return {isOverflow, needsScrollingLeft, needsScrollingRight};
};


